import axios from 'axios';

const BASE_URL = 'https://api.empregos.mobbygov.com/api';

export default axios.create({
  baseURL: BASE_URL,
});
